import { configureStore } from "@reduxjs/toolkit";
import CartSlice from "./slices/CartSlice";
import WishlistSlice from "./slices/WishlistSlice";
import OrderSlice from "./slices/OrdersSlice";
import AuthSlice from "./slices/AuthSlice";
import AddressSlice from "./slices/AddressSlice";
import { saveState, loadState } from "./localStorageUtils";

const preloadedState = loadState();

const store = configureStore({
  reducer: {
    auth: AuthSlice,
    cart: CartSlice,
    wishlist: WishlistSlice,
    orders: OrderSlice,
    address: AddressSlice,
  },
  preloadedState,
});

export default store;
